import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-deep" data-id="element-91" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-92" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-2xl text-gold" data-id="element-93" data-mp="3ghc2o28413o8">
          The No-Prep Chess Club Megapack
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-94" data-mp="32m1ch24t96q7">
          The Print-and-Teach Club System — so you never walk into club
          without knowing exactly what to teach.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-white/70" data-id="element-95" data-mp="3ud7czjog16g0">
          <a href="mailto:help@iclcollective.com" className="hover:text-white hover:underline" data-id="element-96" data-mp="3lec9ifcsaage">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-navy-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-97" data-mp="3qbvo5gde8p8v">
          The No-Prep Chess Club Megapack is an educational resource for chess
          coaches and club leaders. It does not replace your school&apos;s or
          organization&apos;s policies on supervision and child safety, or the
          rules of any chess federation. Results depend on each group; no
          rating or competitive result is guaranteed. Not affiliated with or
          endorsed by any chess federation, school or online chess platform.
          &copy; The No-Prep Chess Club Megapack 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}